//DBTables
// import { DBBuilding } from "../../types/DBTables";
import { Button, Modal } from "react-bootstrap";
import { useCallback, useEffect, useState } from "react";
import { get, post, updateUserInfo } from "../../../modules/server";
import Notify from "devextreme/ui/notify";
import HtmlEditor from "devextreme-react/html-editor";
import { logAndNotifyError, logErrorSilently } from "../../../modules/logger";
import { useGlobalData } from "../../GlobalDataProvider";

//interface IProps {}

const GetStartedDialog = () => {
  const globalData = useGlobalData();
  const [show, setShow] = useState(false);
  const [header, setHeader] = useState("");
  const [body, setBody] = useState("");
  //const [showGetStarted, setShowGetStarted] = useState<boolean>(globalData?.user?.dontShowGetStarted === true ? false : true);

  const showGetStarted = globalData?.user?.dontShowGetStarted === true ? false : true;
  const handleClose = () => {
    setShow(false);
  };

  const handleShowGetStartedChanged = async (e: any) => {
    const user = globalData.user;
    if (user) {
      user.dontShowGetStarted = !e.target.checked;

      updateUserInfo(user);
      const response = await post("User/SetDontShowGetStarted", { dontShowGetStarted: user.dontShowGetStarted });
      const dbg = response;
    }
  };

  useEffect(() => {
    PubSub.subscribe("ShowGetStarted", async () => {
      if (!body) {
        const response = await get("GetSystemText/home");
        //const response = await get("GetHelp/testHelp");
        if (response.success) {
          setHeader(response.text.title);
          setBody(response.text.body);
          setShow(true);
        } else {
          Notify("Kom-igång kunde inte visas", "error");
          logErrorSilently("Kom-igång hittades inte");
        }
      } else {
        setShow(true);
      }
    });
  }, [body]);

  return (
    <div style={{ display: show ? "block" : "none" }}>
      {show ? (
        <>
          <Modal show={show} onHide={handleClose} size="xl" centered={false} scrollable={true}>
            <Modal.Header closeButton className="bg-success bg-gradient text-white">
              <Modal.Title>{header}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <HtmlEditor valueType="html" value={body} className="HtmlEditor" readOnly></HtmlEditor>
            </Modal.Body>
            <Modal.Footer className="justify-content-between">
              <div className="form-check">
                <label className="form-check-label">
                  <input className="form-check-input" type="checkbox" checked={showGetStarted} onChange={handleShowGetStartedChanged} />
                  Visa kom-igång vid uppstart
                </label>
              </div>

              <Button variant="secondary" onClick={handleClose}>
                Close
              </Button>
            </Modal.Footer>
          </Modal>
        </>
      ) : (
        <> </>
      )}
    </div>
  );
};

export default GetStartedDialog;
